import { SvgBase } from "../svg.base";

export const Devices: React.FC<{ size?: number }> = ({ size }) => (
    <SvgBase
        width={"" + (size || 24)}
        height={"" + (size || 24)}
        viewBox="0 0 24 24"
    >
        <g fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
                <g>
                    <path d="M22 4.25v1.5l-17.278.002-.233.008c-.566.034-.7.176-.73.736l-.007.23L3.75 18H14v2.5H0V18h2.25V7c0-1.856.536-2.693 2.538-2.747L5 4.25h17zM23 8c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1h-6c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h6zm-.5 1.5h-5v9h5v-9z" transform="translate(-1302.000000, -354.000000) translate(1302.000000, 354.000000)" />
                </g>
            </g>
        </g>
    </SvgBase>
);



